
import BreadcrumbView from "../common/breadcrumb/breadcrumb.html";
import PersonsTreatmentsListView from "./persons_treatments-list.html";
import PersonsTreatmentsEditView from "./persons_treatments-edit.html";

angular.module("persons_treatments", [])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
           .state('persons_treatments', {
               url: "/persons_treatments",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView,
                cache: false,
            })
            .state('persons_treatments.list', {
                url: "/list",
                controller: "PersonsTreatmentsListCtrl",
                template: PersonsTreatmentsListView,
                data: { pageTitle: 'Tratamientos' },
                cache: false,
                requiredPermission: ["PERSONS_TREATMENTS_READ"]
            })
            .state('persons_treatments.edit', {
                url: "/edit/:id",
                controller: "PersonsTreatmentsEditCtrl",
                template: PersonsTreatmentsEditView,
                data: { pageTitle: 'Tratamientos' },
                cache: false,
                requiredPermission: ["PERSONS_TREATMENTS_READ"]
            })
        ;
    }])
;